export const PROPORTIONAL_GROUP_FONT_SCALEDOWN_FACTOR = 0.96
export const TEXT_SCALE_FACTOR = 1
export const MAX_SCALE_FACTOR = 1
export const GRAPHIC_MARKER_MIN_WIDTH = 40
